import { connectHitsPerPage } from 'react-instantsearch-dom';

// https://www.algolia.com/doc/guides/building-search-ui/widgets/customize-an-existing-widget/react/#virtual-widgets

const VirtualHitsPerPage = connectHitsPerPage(() => null);

export default VirtualHitsPerPage;
